import React from 'react'
import styled from "styled-components";
import { useContractRead, useContractReads } from "wagmi";
import { jungleAbi, JungleCA } from '@/utils/abi'
import { ethers } from "ethers";
import { useMemo } from "react";
import { numberWithCommas } from '@/utils/index'
import { ReactSVG } from 'react-svg'
import handImg from "@/assets/svg/hand.svg";
import { useWhiteList } from '../../hooks/index.js'


export default function Tvl({ isLogin }) {
  const isWhiteList = useWhiteList()
  // !isWhiteList && 
  const jungleContract = {
    address: JungleCA,
    abi: jungleAbi,
  }
  const { data, isError, isLoading } = useContractReads({
    contracts: [
      {
        ...jungleContract,
        functionName: 'totalCollateral',
      },
      {
        ...jungleContract,
        functionName: 'totalIssuedSynths',
        args:[0]
      }      
    ],
    watch: true,
  })
  
  const tvlFomat = useMemo(() =>     
    ethers.utils.formatEther(data?.[0] || 0)
  , [data]);

  const tldFomat = useMemo(() =>     
  ethers.utils.formatEther(data?.[1] || 0)
  , [data]);

  
  return (
    <TvlWrapper>
      {
        (!isLogin || !isWhiteList) && <TvlTitle>
        <ReactSVG className="ques-img" src={handImg}/>
          Welcome to Jungle Protocol
      </TvlTitle>
      }
      {
        (!isLogin || !isWhiteList) ? <Values>
        <ValueItem>
          <Dollar>${numberWithCommas(tvlFomat)}</Dollar>
          <BotText>Total Value Staked</BotText>
        </ValueItem>
        <ValueItem>
          <Dollar>${numberWithCommas(tldFomat)}</Dollar>
          <BotText>Total Liquid Debt</BotText>
        </ValueItem>
      </Values> 
      :
       <Rows>
        <Column>
          <div className='numbber'>${numberWithCommas(tvlFomat)}</div>
          <span className='tvl-text'>Total Value Staked</span>
        </Column>
        <ColumnLine></ColumnLine>
        <Column>
          <div className='numbber'>${numberWithCommas(tldFomat)}</div>
          <span className='tvl-text'>Total Liquid Debt</span>
        </Column>
      </Rows>
      }
      
    </TvlWrapper>
  )
}


const TvlWrapper = styled.div`

`

const TvlTitle = styled.div`
  display: flex;
  align-items: center;
  padding-left:15px;
  margin-bottom: 43px;
  font-weight: 600;
  font-size: 40px;
  line-height: 56px;
`

const Values = styled.div`
  display: flex;
`

const ValueItem = styled.div`
  width: 432px;
  height: 203px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 12px;  
  background: rgba(255, 255, 255, 0.1);
  & + &{
    margin-left:60px;
  } 
`
const Dollar = styled.div`
  font-weight: 600;
  font-size: 50px;
  line-height: 70px;
`
const BotText = styled.span`

`
const Rows = styled.div`
  min-width: 760px;
  width: 50vw;
  height: 164px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius:12px;
  margin-top: 12px;
`
const Column = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

.numbber{
  font-weight: 600;
  font-size: 34px;
  line-height: 48px;  
  color: #fff;
}
.tvl-text{
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.6);
}
`
const ColumnLine = styled.div`
  width: 1px;
  height:24px;  
  background: rgba(255, 255, 255, 0.1);
`
